import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/MobileApp.css'
import mobileHero from "../../../assets/images/mobileappdevelopment.png";
import mobileAppsImg from "../../../assets/images/mobileappdevelopment.png";

const MobileAppDevelopment = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Mobile App Development – BuddyTech Solutions </title>
        <meta name="description" content="Native and cross‑platform mobile apps (React Native, Flutter) built for iOS and Android." />
        <meta name="keywords" content="mobile app development, React Native, Flutter" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Mobile App Development – BuddyTech Solutions" />
        <meta property="og:description" content="Native and cross‑platform mobile apps (React Native, Flutter) built for iOS and Android." />
        <meta property="og:keywords" content="mobile app development, React Native, Flutter" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/development/mobileapp" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mobile App Development – BuddyTech Solutions" />
        <meta name="twitter:description" content="Native and cross‑platform mobile apps (React Native, Flutter) built for iOS and Android." />
        <meta name="twitter:keywords" content="mobile app development, React Native, Flutter" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="mobile-container">
        <header className="mobile-hero">
          <div className="mobile-hero-content">
            <h1>Mobile App Development</h1>
            <p>
              We create high-performance mobile applications tailored for iOS, Android, and cross-platform environments.
            </p>
          </div>
          <img src={mobileHero} alt="Mobile Development" className="mobile-hero-img" />
        </header>

        <section className="mobile-section">
          <div className="mobile-text">
            <h2>What We Offer</h2>
            <p>
              Our mobile solutions focus on seamless user experiences, smooth performance, and robust architecture—ensuring your app delights users and scales effortlessly.
            </p>
            <ul>
              <li>Native & Cross-platform Development</li>
              <li>UI/UX Design for Mobile</li>
              <li>Backend Integration & APIs</li>
              <li>Performance Optimization</li>
              <li>App Store Deployment & Maintenance</li>
            </ul>
          </div>
          <img src={mobileAppsImg} alt="App Screens" className="mobile-img" />
        </section>

        <section className="mobile-tools">
          <h2>Technologies We Use</h2>
          <div className="tools-grid">
            <span>Flutter</span>
            <span>React Native</span>
            <span>Kotlin</span>
            <span>Swift</span>
            <span>Java</span>
            <span>Firebase</span>
            <span>Expo</span>
            <span>Redux</span>
            <span>GraphQL</span>
            <span>SQLite</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default MobileAppDevelopment;